import React from 'react';
import ProcurementContent from './content';
import { ProcurementProvider } from 'contexts/procurement.context';

const ProcurementLayout = () => {
  return (
    <ProcurementProvider>
      <ProcurementContent />
    </ProcurementProvider>
  );
};

export default ProcurementLayout;
